<template>
  <div class="dashboard-chart-bar">
    <h2>{{ charttitle }}</h2>
    <div class="chart-components-container" :style="'height:' + chartheight + ';'">
      <div class="chart-components-content" :style="'height:' + chartheight + ';'" :id="chartid"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BarChart',

  props: {
    chartheight: String,
    charttitle: String,
    chartid: String,
    legendtype: String,
    chartdata: Array
  },
  created() {
    this.$nextTick(() => {
      this.initPieChart(this.chartdata)
    });
  },
  watch: {
    'chartdata'() {
      this.$nextTick(() => {
        this.initPieChart(this.chartdata)
      });
    },
  },

  methods: {
    initPieChart: function(chartdata){
      if(document.getElementById(this.chartid) === null) return
      let ec = this.$echarts
      let myBarChart = ec.init(document.getElementById(this.chartid))
      let that = this
      myBarChart.clear()
      myBarChart.setOption({
        legend: {
          top: 0,
          right: 30,
          icon: 'rect'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        grid: {
          left: 40,
          top: 20,
          bottom: 20,
          right:20,
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 0,
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          data: ['0%-20%', '21%-40%', '41%-60%', '61%-80%', '81%-100%']
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 'auto',
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#EAEAEA',
            }
          }
        },
        series: [{
          data: chartdata,
          type: 'bar',
          barWidth: '20',
        }],
        color: ['#7290F2', '#F47373', '#F49256', '#F4C36F', '#8D7CED', '#CED2EB', '#D9D9D9']
      })
      $(window).resize(function () {
          myBarChart.resize();
      }); 
    }
  },

}
</script>